module.exports = __webpack_public_path__ + "img/arraykart-icon.f8c4bcea.png";